import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const faqs = [
  { q: "How do I make a booking?", a: "Browse our fleet, pick your dates and vehicle, fill out the reservation form, and pay securely via Stripe. You'll receive a confirmation with your booking reference." },
  { q: "Is insurance included?", a: "Yes — every rental includes comprehensive third-party liability coverage. Optional collision damage waiver and personal accident insurance can be added at checkout." },
  { q: "What are the driver requirements?", a: "You must be at least 21 years old (25 for luxury vehicles), hold a valid driver's license for at least 1 year, and present a major credit card at pickup." },
  { q: "What payment methods do you accept?", a: "All major credit and debit cards via Stripe. Corporate customers can request invoicing." },
  { q: "What is your fuel policy?", a: "Vehicles are delivered with a full tank and should be returned full. A refuelling fee applies otherwise." },
  { q: "Are there mileage limits?", a: "Daily rentals include 200 miles/day. Weekly and monthly rentals include generous mileage packages. Unlimited mileage upgrades are available." },
  { q: "What is your cancellation policy?", a: "Free cancellation up to 24 hours before pickup. Cancellations within 24 hours incur a one-day charge." },
  { q: "What happens if I return late?", a: "A grace period of 30 minutes is provided. Beyond that, a prorated hourly late fee applies up to a maximum of one day's rental." },
];

export default function FAQ() {
  return (
    <div className="max-w-3xl mx-auto px-6 py-24">
      <div className="eyebrow mb-3" style={{ color: "#0B1F3A" }}>FAQ</div>
      <h1 className="font-display font-extrabold text-5xl tracking-tighter mb-10">Frequently asked questions</h1>
      <Accordion type="single" collapsible className="space-y-3">
        {faqs.map((f, i) => (
          <AccordionItem key={i} value={`item-${i}`} className="bg-white rounded-xl border border-black/5 px-5" data-testid={`faq-${i}`}>
            <AccordionTrigger className="text-left font-display font-semibold text-lg hover:no-underline">{f.q}</AccordionTrigger>
            <AccordionContent className="text-[#0B1F3A]/70 leading-relaxed">{f.a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
}
